import { z } from 'zod';
import { ANALYTICS_BATCH_MAX_EVENTS } from '../constants.js';
import { analyticsEventNameSchema } from '../enums.js';
/**
 * Contrat d'**ingestion de l'analytique d'usage** (ADR-0026, FR-46). La minimisation n'est pas une
 * consigne, elle est **imposée par le schéma** : ce qui n'entre pas ici n'est jamais stocké.
 */
/** Nombre maximal de propriétés par événement — borne la cardinalité, décourage le fourre-tout. */
const MAX_PROPS = 12;
/** Clé de propriété : identifiant court en snake_case. Pas de clé arbitraire. */
const propKeySchema = z.string().regex(/^[a-z][a-z0-9_]{0,31}$/);
/**
 * Valeur de propriété : nombre, booléen, ou **jeton court** sans espace ni séparateur d'URL/e-mail.
 * Le motif exclut structurellement l'espace, `@`, `/`, `?`, `#` — donc ni phrase, ni e-mail, ni URL,
 * ni chemin de fichier. On mesure des catégories et des compteurs, jamais du contenu (ADR-0026 §2).
 */
const propValueSchema = z.union([
    z.number().finite(),
    z.boolean(),
    z.string().regex(/^[A-Za-z0-9_.:-]{1,64}$/),
]);
export const analyticsPropsSchema = z
    .record(propKeySchema, propValueSchema)
    .refine((props) => Object.keys(props).length <= MAX_PROPS, {
    message: `Au plus ${MAX_PROPS} propriétés par événement.`,
});
/** Un événement d'usage émis par le client. `occurredAt` : instant côté client (le serveur horodate sa réception à part). */
export const analyticsEventInputSchema = z.object({
    name: analyticsEventNameSchema,
    occurredAt: z.coerce.date(),
    props: analyticsPropsSchema.optional(),
});
/**
 * Un **lot** d'événements (ADR-0026 §3). `sessionId` : identifiant de session **éphémère** généré par
 * le client, opaque et non relié à l'identité (jamais l'`userId`, jamais un jeton). L'`organizationId`
 * n'est **pas** dans le corps : il vient du contexte authentifié, pour qu'un client ne falsifie pas
 * l'attribution.
 */
export const analyticsBatchSchema = z.object({
    sessionId: z
        .string()
        .regex(/^[A-Za-z0-9_-]{1,64}$/)
        .optional(),
    events: z.array(analyticsEventInputSchema).min(1).max(ANALYTICS_BATCH_MAX_EVENTS),
});
//# sourceMappingURL=analytics.js.map